// npm の shuffle-text を静的インポート（バンドルに含める）
import ShuffleText from 'shuffle-text';

// 要素がビューポートに入ったときにシャッフルを開始
document.addEventListener('DOMContentLoaded', () => {
  if (!ShuffleText) return;
  const candidates = document.querySelectorAll(
    ".site-title span, .site-nav span, .site-desc, .post-entry-title > span, .post-title"
  );
  if (!candidates.length) return;

  const start = (el) => {
    const st = new ShuffleText(el);
    st.start();
  };

  // 要素内のテキストノードのみを span でラップして返す（リンク等は保持）
  const wrapTextNodes = (root) => {
    if (root.dataset.shuffleWrapped === '1') {
      return [...root.querySelectorAll('span.js-shuffle-part')];
    }
    const SKIP_SELECTOR = 'script,style,code,pre,kbd,samp';
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    const targets = [];
    let node;
    while ((node = walker.nextNode())) {
      const text = node.nodeValue || '';
      if (!text.trim()) continue; // 空白のみは除外
      const parentEl = node.parentElement;
      if (!parentEl || parentEl.closest(SKIP_SELECTOR)) continue; // コード系は除外
      targets.push(node);
    }
    const parts = [];
    targets.forEach((textNode) => {
      const span = document.createElement('span');
      span.className = 'js-shuffle-part';
      span.textContent = textNode.nodeValue;
      textNode.parentNode.replaceChild(span, textNode);
      parts.push(span);
    });
    if (parts.length) root.dataset.shuffleWrapped = '1';
    return parts;
  };

  const startOnElementOrParts = (el) => {
    if (el.dataset.shuffleDone === '1') return;
    const parts = wrapTextNodes(el);
    if (parts.length) {
      parts.forEach((p) => start(p));
    } else {
      start(el);
    }
    // el.dataset.shuffleDone = '1';
  };

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          startOnElementOrParts(entry.target);
          // observer.unobserve(entry.target); // 1回だけ発火
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    [...candidates].forEach((el) => io.observe(el));
  } else {
    // フォールバック: 監視できない環境では即時発火
    [...candidates].forEach((el) => startOnElementOrParts(el));
  }
});
